import React from "react";
import { profile, stats, credentials } from "../mock/mock";
import { Check } from "lucide-react";

const About = () => {
  return (
    <section id="about" aria-labelledby="about-heading" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left label column */}
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6b6b66] mb-3">
              — (01) About
            </p>
            <h2 id="about-heading" className="font-display text-3xl md:text-4xl font-medium leading-tight">
              A practice, not<br />an agency.
            </h2>
          </div>

          {/* Right content */}
          <div className="lg:col-span-9 space-y-10">
            <p className="font-display text-2xl md:text-3xl lg:text-[34px] leading-[1.25] font-light text-[#1a1a1a]">
              For eighteen years I&apos;ve helped brands win the search results page. Today
              the search results page is being rewritten — by{" "}
              <span className="italic">large language models</span>, by{" "}
              <span className="italic">answer engines</span>, by an audience that
              increasingly never clicks. My work is to make sure the brands I
              partner with don&apos;t just survive that shift, but compound through it.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 pt-6">
              <div>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#6b6b66] mb-4">
                  Background
                </p>
                <p className="text-[15px] leading-relaxed text-[#2a2a2a]">
                  Former Head of Organic Growth for an EMEA SaaS platform, now an
                  independent strategist working with founders and growth teams
                  who refuse to be invisible. I run small, senior engagements
                  — typically 3 to 6 months, fewer than 8 clients a year.
                </p>
              </div>
              <div>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#6b6b66] mb-4">
                  Recognition
                </p>
                <ul className="space-y-3">
                  {credentials.map((c) => (
                    <li key={c} className="flex gap-3 text-[15px] text-[#2a2a2a]">
                      <Check className="h-4 w-4 mt-1 text-[#0A0A0A] shrink-0" />
                      <span>{c}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-20 md:mt-24 grid grid-cols-2 md:grid-cols-4 border-t border-[#E5E5E0]">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`py-8 md:py-10 px-4 md:px-6 ${
                i !== 0 ? "md:border-l border-[#E5E5E0]" : ""
              } ${i % 2 === 1 ? "border-l border-[#E5E5E0] md:border-l" : ""}`}
            >
              <div className="font-display text-5xl md:text-6xl font-medium leading-none">
                {s.value}
              </div>
              <div className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[#6b6b66]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
